import React, { useState, useEffect } from 'react';
import { Breadcrumb } from 'antd';
import { HomeOutlined, SaveOutlined } from '@ant-design/icons';
import { Link, useParams } from 'react-router-dom';
import Bread from 'modules/layoutModule/components/Bread/Bread';
import {
  getSpecificNewsCategoryRequest,
  saveNewsCategoryRequest,
} from 'modules/newsModule/requests/newsRequests';
import ActivitySwitch from 'modules/layoutModule/components/ActivitySwitch/ActivitySwitch';
import {
  Form,
  Input,
  Button,
  Space,
  Skeleton,
  ConfigProvider,
  BackTop,
} from 'antd';
import { FieldData } from 'rc-field-form/lib/interface';
import { useHistory } from 'react-router-dom';
import plPL from 'antd/lib/locale/pl_PL';

import 'moment/locale/pl';

const NewsCategoriesEdit = (): JSX.Element => {
  const { id } = useParams<{ id: string }>();
  const [form] = Form.useForm();
  const [fields, setFields] = useState<FieldData[]>([]);
  const [loading, toggleLoading] = useState<boolean>(false);
  const history = useHistory();
  const [isSaveButtonLoading, toggleButtonLoading] = useState(false);
  const [isActivityDisabled, toggleActivityDisable] = useState(false);

  useEffect(() => {
    toggleLoading(true);
    getSpecificNewsCategoryRequest(id)
      .then((response) => {
        if (response) {
          toggleLoading(false);
          const { data } = response;
          setFields([
            {
              name: ['id'],
              value: data.id,
            },
            {
              name: ['title'],
              value: data.name,
            },
            {
              name: ['sortOrder'],
              value: data.sortOrder,
            },
            {
              name: ['isActive'],
              value: data.isActive || false,
            },
          ]);
          if (data.activitySwitchDisabled) {
            toggleActivityDisable(true);
          }
        } else {
          history.push('/news-categories');
        }
      })
      .catch(() => {
        history.push('/news-categories');
      });
  }, []);

  const onFinish = (values: any) => {
    toggleButtonLoading(true);
    saveNewsCategoryRequest(values).then(() => {
      toggleButtonLoading(false);
    });
  };

  const validateMessages = {
    required: 'Proszę uzupełnić pole ${label}!',
    types: {
      email: '${label} is not a valid email!',
      number: '${label} is not a valid number!',
    },
    number: {
      range: '${label} must be between ${min} and ${max}',
    },
  };

  return (
    <>
      <Bread>
        <>
          <Breadcrumb.Item>
            <HomeOutlined />
          </Breadcrumb.Item>
          <Breadcrumb.Item>Aktualności</Breadcrumb.Item>
          <Breadcrumb.Item>
            <Link to="/news/categories">Kategorie</Link>
          </Breadcrumb.Item>
          <Breadcrumb.Item>
            <Link to={`/news/categories/${id}`}>Edycja wpisu</Link>
          </Breadcrumb.Item>
        </>
      </Bread>
      <ConfigProvider locale={plPL}>
        <div className="site-layout-background">
          {loading && <Skeleton active />}
          {!loading && (
            <Form
              layout="vertical"
              fields={fields}
              onFinish={onFinish}
              form={form}
              validateMessages={validateMessages}
            >
              <Form.Item name="id" hidden>
                <Input />
              </Form.Item>
              <Form.Item
                name="title"
                label="Nazwa"
                rules={[
                  {
                    required: true,
                  },
                ]}
              >
                <Input />
              </Form.Item>
              <Form.Item
                name="sortOrder"
                label="Kolejność"
                rules={[
                  {
                    required: true,
                  },
                  {
                    validator: async (_, value) => {
                      if (value) {
                        if (
                          (value.length > 5 ||
                            !/^[0-9]*\,?\.?[0-9]*$/.test(value)) &&
                          value.length > 0
                        ) {
                          return Promise.reject(
                            new Error('Proszę podać poprawną wartość!')
                          );
                        }
                      }
                    },
                  },
                ]}
              >
                <Input
                  style={{
                    width: '100px',
                  }}
                />
              </Form.Item>
              <ActivitySwitch isActivityDisabled={isActivityDisabled} />
              <Form.Item>
                <Space>
                  <Button
                    type="primary"
                    htmlType="submit"
                    icon={<SaveOutlined />}
                    loading={isSaveButtonLoading}
                  >
                    Zapisz
                  </Button>
                  <Link to="/news/categories">
                    <Button>Powrót</Button>
                  </Link>
                </Space>
              </Form.Item>
            </Form>
          )}
          {loading && (
            <Link to="/news/categories">
              <Button>Powrót</Button>
            </Link>
          )}
          <BackTop />
        </div>
      </ConfigProvider>
    </>
  );
};

export default NewsCategoriesEdit;
